import { TextArea } from "native-base";

export default TextArea;